import Navigation from 'client/components/navigation';
import baseUrl from 'server/routes/base-url';

export default {
  path: baseUrl,
  component: Navigation,
  indexRoute: {
    name: 'landing',
    getComponent: (nextState, cb) => {
      require.ensure([], () => cb(null, require('client/components/landing')));
    },
  },
  childRoutes: [
    {
      path: 'discover',
      name: 'discover',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/discover'))
        );
      },
    },
    {
      path: 'podcasters',
      name: 'podcasters',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/podcasters'))
        );
      },
    },
    {
      path: 'advertisers',
      name: 'advertisers',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/advertisers'))
        );
      },
    },
    {
      path: 'about',
      name: 'about',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/about'))
        );
      },
    },
    {
      path: 'endangeredwords',
      name: 'endangeredwords',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/endangeredwords'))
        );
      },
    },
    {
      path: 'press',
      name: 'press',
      indexRoute: {
        getComponent: (nextState, cb) => {
          require.ensure([], require =>
            cb(null, require('client/components/press'))
          );
        },
      },
      childRoutes: [
        {
          path: 'medias',
          name: 'medias',
          getComponent: (nextState, cb) => {
            require.ensure([], require =>
              cb(null, require('client/components/press'))
            );
          },
        },
        {
          path: 'releases',
          name: 'releases',
          indexRoute: {
            getComponent: (nextState, cb) => {
              require.ensure([], require =>
                cb(null, require('client/components/press'))
              );
            },
          },
          childRoutes: [
            {
              path: ':article',
              getComponent: (nextState, cb) => {
                require.ensure([], require =>
                  cb(null, require('client/components/press/press-article'))
                );
              },
            },
          ],
        },
      ],
    },
    {
      path: 'privacy',
      name: 'privacy',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/privacy'))
        );
      },
    },
    {
      path: 'privacy/se',
      name: 'privacy/se',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/privacy/se'))
        );
      },
    },
    {
      path: 'terms',
      name: 'terms',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/terms'))
        );
      },
    },
    {
      path: 'cookies',
      name: 'cookies',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/cookies'))
        );
      },
    },
    {
      path: 'plus',
      name: 'plus',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/acast-plus'))
        );
      },
    },
    {
      path: 'faq',
      name: 'faq',
      getComponent: (nextState, cb) => {
        require.ensure([], require =>
          cb(null, require('client/components/faq'))
        );
      },
    },
    {
      path: 'jobs',
      name: 'jobs',
      indexRoute: {
        getComponent: (nextState, cb) => {
          require.ensure([], require =>
            cb(null, require('client/components/jobs'))
          );
        },
      },
      childRoutes: [
        {
          path: ':job',
          name: 'job',
          getComponent: (nextState, cb) => {
            require.ensure([], require =>
              cb(null, require('client/components/jobs/job'))
            );
          },
        },
      ],
    },
    {
      path: ':channel',
      name: 'channel',
      indexRoute: {
        getComponent: (nextState, cb) => {
          require.ensure([], require =>
            cb(null, require('client/components/channel'))
          );
        },
      },
      childRoutes: [
        {
          path: ':acast',
          name: 'acast',
          getComponent: (nextState, cb) => {
            require.ensure([], require =>
              cb(null, require('client/components/acast'))
            );
          },
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./client/routes.es6